export default __webpack_public_path__ + "static/media/danskeheadlinebold-webfont.8bd21809.svg";